import type { ComponentThemeStyles } from './types';

export const modernTheme: ComponentThemeStyles = {
  typography: {
    headingFont: 'DM Sans, system-ui, sans-serif',
    bodyFont: 'DM Sans, system-ui, sans-serif',
    baseSize: '16px',
  },
  navbar: {
    background: 'bg-white/95 backdrop-blur-md',
    text: 'text-gray-900',
    brandText: 'text-gray-900',
    linkText: 'text-gray-700',
    linkHover: 'hover:text-gray-900',
    border: '',
    shadow: 'shadow-lg',
    height: 'h-20',
  },
  navigationMenu: {
    background: 'bg-white/95 backdrop-blur-md',
    text: 'text-gray-900',
    brandText: 'text-gray-900',
    linkText: 'text-gray-700',
    linkHover: 'hover:text-gray-900',
    border: '',
    shadow: 'shadow-lg',
    height: 'h-20',
    dropdownBackground: 'bg-white',
    dropdownText: 'text-gray-700',
    dropdownHover: 'hover:bg-gray-50',
  },
  hero: {
    background: 'bg-white',
    text: 'text-gray-900',
    buttonStyle: 'bg-gray-900 text-white hover:bg-gray-800',
    pattern: false,
  },
  splitHero: {
    background: '#ffffff',
    text: '#111827',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
    taglineColor: '#1f2937',
    buttonBg: '#111827',
    buttonText: '#ffffff',
    buttonHover: '#374151',
  },
  htmlSplit: {
    background: '#ffffff',
    text: '#111827',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
    taglineColor: '#1f2937',
    buttonBg: '#111827',
    buttonText: '#ffffff',
    buttonHover: '#374151',
  },
  simpleHeader: {
    background: '#ffffff',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
  },
  features: {
    background: 'bg-white',
    cardBg: 'bg-gray-50',
    iconColor: 'text-gray-900',
    titleColor: 'text-gray-900',
    textColor: 'text-gray-700',
    borderRadius: 'rounded-none',
  },
  footer: {
    background: 'bg-white',
    text: 'text-gray-900',
    mutedText: 'text-gray-500',
    border: 'border-t-2 border-gray-100',
  },
  cta: {
    background: 'bg-gray-100',
    text: 'text-gray-900',
    buttonStyle: 'bg-gray-900 text-white hover:bg-gray-800',
  },
  form: {
    background: 'bg-gray-50',
    inputBg: 'bg-white',
    inputBorder: 'border-gray-200',
    inputText: 'text-gray-900',
    labelColor: 'text-gray-700',
    buttonStyle: 'bg-gray-900 text-white hover:bg-gray-800',
  },
  pricing: {
    background: 'bg-gray-50',
    cardBg: 'bg-white',
    highlightedCard: 'bg-gray-900 text-white',
    titleColor: 'text-gray-900',
    subtitleColor: 'text-gray-700',
    descriptionColor: 'text-gray-600',
    planTitle: 'text-gray-900',
    planDescription: 'text-gray-700',
    priceColor: 'text-gray-900',
    periodColor: 'text-gray-700',
    featureColor: 'text-gray-700',
    checkColor: '#111827',
    highlightedTitle: 'text-white',
    highlightText: '#111827',
    highlightedDescription: 'text-gray-200',
    highlightedPrice: 'text-white',
    highlightedPeriod: 'text-gray-200',
    highlightedFeature: 'text-gray-100',
    highlightedCheckColor: '#ffffff',
    borderColor: 'border-gray-200',
    highlightBorder: 'border-gray-900',
    highlightRing: 'ring-gray-900',
    hoverGlow: 'hover:shadow-gray-900/25',
    badgeBg: '#111827',
    badgeText: 'white',
    buttonBg: '#111827',
    highlightedButtonBg: '#ffffff',
  },
  mediaText: {
    background: '#ffffff',
    titleColor: '#111827',
    textColor: '#374151',
    accentColor: '#111827',
  },
  faq: {
    background: '#ffffff',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    questionColor: '#111827',
    answerColor: '#374151',
    itemBackground: '#f9fafb',
    itemBorder: '#e5e7eb',
    iconColor: '#111827',
  },
  testimonials: {
    background: '#f9fafb',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    cardBackground: '#ffffff',
    cardBorder: '#e5e7eb',
    quoteColor: '#374151',
    nameColor: '#111827',
    roleColor: '#6b7280',
    starColor: '#111827',
  },
  countdownTimer: {
    background: '#ffffff',
    text: '#111827',
    headline: '#111827',
    subheadline: '#6b7280',
    number: '#111827',
    label: '#6b7280',
  },
  imageGallery: {
    background: '#ffffff',
    text: '#111827',
    title: '#111827',
    subtitle: '#6b7280',
    caption: '#4b5563',
    filterButton: '#f3f4f6',
    filterButtonActive: '#111827',
  },
  imageInfo: {
    background: '#ffffff',
    text: '#111827',
    title: '#111827',
    subtitle: '#6b7280',
    imageBorder: '#f3f4f6',
    buttonBg: '#111827',
    buttonText: '#ffffff',
  },
  imageCard: {
    background: '#ffffff',
    overlayColor: '#000000',
    title: '#ffffff',
    description: '#f3f4f6',
    buttonBg: '#111827',
    buttonText: '#ffffff',
  },
  team: {
    background: '#ffffff',
    cardBg: '#f9fafb',
    nameColor: '#111827',
    roleColor: '#6b7280',
    borderColor: '#e5e7eb',
  },
  video: {
    background: '#f9fafb',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    textColor: '#4b5563',
  },
  textBlocks: {
    background: '#ffffff',
    titleColor: '#111827',
    textColor: '#4b5563',
    linkColor: '#111827',
  },
  titleSubtitle: {
    background: '#ffffff',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    buttonBg: '#111827',
    buttonText: '#ffffff',
  },
  contactInfo: {
    background: '#f9fafb',
    titleColor: '#111827',
    textColor: '#4b5563',
    accentColor: '#111827',
  },
  headContent: {},
  bodyEnd: {},
  htmlEmbed: {
    background: '#ffffff',
  },
  promoBanner: {
    background: '#111827',
    text: '#ffffff',
    linkText: '#ffffff',
    dismissButton: '#ffffff',
  },
  logocloud: {
    background: '#ffffff',
    titleColor: '#111827',
    subtitleColor: '#4b5563',
  },
  stats: {
    background: '#f8fafc',
    titleColor: '#0f172a',
    subtitleColor: '#475569',
    valueColor: '#2563eb',
    labelColor: '#0f172a',
    descriptionColor: '#64748b',
  },
  blogPreview: {
    background: '#f9fafb',
    titleColor: '#0f172a',
    subtitleColor: '#475569',
    cardBackground: '#ffffff',
    cardTitle: '#111827',
    cardExcerpt: '#4b5563',
    linkColor: '#2563eb',
  },
  conversionPopup: {
    overlay: 'rgba(0,0,0,0.55)',
    panelBackground: '#ffffff',
    headlineColor: '#111827',
    bodyTextColor: '#374151',
    buttonBackground: '#2563eb',
    buttonText: '#ffffff',
    closeButton: '#6b7280',
  },
  blog: {
    pageBackground: '#f9fafb',
    headerBackground: '#ffffff',
    titleColor: '#111827',
    descriptionColor: '#374151',
    textColor: '#374151',
    mutedTextColor: '#6b7280',
    linkColor: '#111827',
    linkHoverColor: '#374151',
    cardBackground: '#ffffff',
    cardBorder: '#e5e7eb',
    cardShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    cardHoverShadow: '0 10px 15px rgba(0, 0, 0, 0.1)',
    postTitleColor: '#111827',
    postTextColor: '#374151',
    postMetaColor: '#6b7280',
    tagBackground: '#f3f4f6',
    tagText: '#374151',
    tagActiveBackground: '#111827',
    tagActiveText: '#ffffff',
    sidebarBackground: '#ffffff',
    sidebarTitleColor: '#111827',
    paginationBackground: '#ffffff',
    paginationText: '#374151',
    paginationBorder: '#e5e7eb',
    paginationActiveBackground: '#111827',
    paginationActiveText: '#ffffff',
    paginationDisabledOpacity: '0.5',
    iconColor: '#6b7280',
    loadingSpinnerColor: '#111827',
    errorIconColor: '#9ca3af',
    errorButtonBackground: '#111827',
    errorButtonText: '#ffffff',
  },
};
